import { Application } from '../../apis/eols-app-link/eols-app-link.constants';
import { ApplicationNavigateHandlerMapProps, AssignmentTypeStrategy } from '../model';
import { commonAssignmentInfoHandler,
  getShadowHealthTitle,
  getShadowHealthTitleClone,
  navigateExternal,
  shadowHealthCatalogTitleClick,
  shadowHealthClickSettings,
  shadowHealthPerformanceReportClick,
  shadowHealthSortCatalogItemsWithoutTaxonomy,
  shadowHealthSortCatalogItemsWithoutTaxonomyClone,
  shadowHealthTitleClick } from '../utils/common.utils';
import { getShadowHealthAssignmentInfo } from '../../pages/shadow-health-assignment-editor/assignment-type-shadow-health-shared.utils';

export const shadowHealthAssignment: AssignmentTypeStrategy = {
  coursePlanTitleClick: shadowHealthTitleClick,
  coursePlanClickSettings: shadowHealthClickSettings,
  coursePlanPerformanceReportClick: shadowHealthPerformanceReportClick,
  catalogPageTitleClick: shadowHealthCatalogTitleClick,
  assignmentOverviewTitleClick: (props: ApplicationNavigateHandlerMapProps) => navigateExternal(props),
  assignmentOverviewPerformanceReportClick: (props: ApplicationNavigateHandlerMapProps) => navigateExternal(props),
  navigateToAppForAssignmentPerformanceHandlerMap: () => Application.SHADOW_HEALTH,
  navigateToAppHandlerMap: () => Application.SHADOW_HEALTH,
  assignmentInfoHandler: (props) => commonAssignmentInfoHandler(getShadowHealthAssignmentInfo)(props),
  isScorable: true,
  recContentItemTitleHandler: getShadowHealthTitle,
  recContentItemTitleHandlerClone: getShadowHealthTitleClone,
  sortCatalogItemsWithoutTaxonomy: shadowHealthSortCatalogItemsWithoutTaxonomy,
  sortCatalogItemsWithoutTaxonomyClone: shadowHealthSortCatalogItemsWithoutTaxonomyClone
};
